<template>
  <a-carousel
    ref="carouselRef"
    class="carousel"
    arrows
    :autoplay="true"
    :autoplaySpeed="autoplaySpeed"
    :afterChange="onAfterChange"
    :beforeChange="onBeforeChange"
  >
    <template #prevArrow>
      <div class="custom-slick-arrow left">
        <iconpark-icon name="arrow-left"></iconpark-icon>
      </div>
    </template>
    <template #nextArrow>
      <div class="custom-slick-arrow right">
        <iconpark-icon name="arrow-right"></iconpark-icon>
      </div>
    </template>
    <slot />
  </a-carousel>
</template>
<script lang="ts" setup>
withDefaults(
  defineProps<{
    autoplaySpeed?: number;
  }>(),
  {
    autoplaySpeed: 3000,
  },
);

const carouselRef = ref();
const emit = defineEmits(['afterChange', 'beforeChange']);
const onAfterChange = (current: number) => {
  emit('afterChange', current);
};

const onBeforeChange = (current: number) => {
  emit('beforeChange', current);
};

defineExpose({
  goTo(index: number) {
    carouselRef.value?.goTo(index);
  },
});
</script>
<style lang="scss" scoped>
.custom-slick-arrow {
  z-index: 10;
  display: none !important;
  width: 32px;
  height: 32px;
  &.left {
    left: 10px;
  }
  &.right {
    right: 10px;
  }
  iconpark-icon {
    font-size: 32px;
  }
}

.carousel {
  &:hover {
    .custom-slick-arrow {
      display: flex !important;
    }
  }

  :deep(.slick-slide > div) {
    line-height: 0;
  }
}
</style>
